var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPptFreight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 114,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-480 -509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.625 23.1562 17.8125 33.9625 57 57.7125 74.8125 46.9062Z",
    fill: "#256A77",
    transform: "matrix(1.12281 0 0 1 480 509)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1875 33.9625 57 10.2125 40.1375 20.425 79.325 44.175Z",
    fill: "#256A77",
    transform: "matrix(1.12281 0 0 1 480 509)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 43.4625 17.8125 81.4625 54.625 103.787 54.625 61.8687 17.8125 39.5438Z",
    fill: "#256A77",
    transform: "matrix(1.12281 0 0 1 480 509)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4375 68.4 64.125 73.15 64.125 64.8375 72.4375 60.0875 72.4375 68.4ZM59.375 61.8687 59.375 103.787 96.1875 81.4625 96.1875 39.5438 59.375 61.8687Z",
    fill: "#256A77",
    transform: "matrix(1.12281 0 0 1 480 509)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptFreight);
export default __webpack_public_path__ + "static/media/pptFreight.9aebb48c78e01d8b5217a1ae09d1b7cc.svg";
export { ForwardRef as ReactComponent };